import React, { useState } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import saveAs from 'file-saver';

import { usePokCore } from '../../../common/hooks/usePokCore';
import { useNotifications } from '../../../common/hooks/useNotifications';
import { useTranslation } from '../../../common/hooks/useTranslation';
import Button from '../../../common/components/Button/Button';

export const DownloadZIPLink = (props: { fileName: string }) => {
  const pok = usePokCore();
  const notifications = useNotifications();
  const { t, tk } = useTranslation('commonLng');
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = () => {
    setIsLoading(true);
    pok.downloadDoc
      .getZipByName(props.fileName)
      .then(blob => {
        if (blob) {
          saveAs(blob, props.fileName);
          setIsLoading(false);
        }
      })
      .catch(errorResponse => {
        setIsLoading(false);
        notifications.caughtError(errorResponse);
      });
  };

  return (
    <>
      <OverlayTrigger
        overlay={
          <Tooltip style={{ position: 'fixed' }}>
            {t(tk.download.fileNameDownload)}
          </Tooltip>
        }
      >
        <Button
          onClick={e => {
            e.stopPropagation();
            handleClick();
          }}
          variant="btn-info"
          isLoading={isLoading}
        >
          <Icon.Download />
        </Button>
      </OverlayTrigger>
    </>
  );
};
